<script>
import { getBaseApiUrl } from "../api/base";

// const pht_url = localStorage.getItem('pht_url');
const pht_url = getBaseApiUrl();
localStorage.clear()
window.location.replace(pht_url + 'accounts/logout/')
</script>